var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',{staticClass:"config-fee-summary-container"},[_c('div',{staticStyle:{"height":"300px","width":"100%"},attrs:{"id":"configFeeSummary"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }